import { mapActions } from 'vuex'
import { eventBus } from '@/main'

export default {
    computed: {
        StudentFirstName() { return this.student?.EffectiveForenames; },
        StudentSurname() { return this.student?.EffectiveSurname; },
        StudentDisplayName() { return `${this.StudentFirstName} ${this.StudentSurname}`; }
    },
    methods: {
        ...mapActions({
            FetchStudent: 'enterpriseDataApi/FetchStudent',
        }),
        LoadStudent() {
            this.loadingStudent = true;
            this.FetchStudent()
                .then(response => {
                    this.student = CoalesceJSON(response);
                    eventBus.$emit('student-fetch:success', this.student);
                })
                .catch(error => eventBus.$emit('student-fetch:failed', error))
                .finally(() => this.loadingStudent = false);
        },
    }
};
function CoalesceJSON(object, returnObject) {
    if (object == null) return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};
